import { RootEpic } from 'typesafe-actions';

import { createGetEpic, createPaginatedGetEpic } from '../utils';
import { getBlockByHashAsync, getPaginatedBlocksAsync } from './actions';

export const loadBlocks: RootEpic = (
  action$,
  state$,
  { getPaginatedBlocksSubscription }
) =>
  createPaginatedGetEpic(
    action$,
    getPaginatedBlocksAsync,
    getPaginatedBlocksSubscription
  );

export const loadBlock: RootEpic = (
  action$,
  state$,
  { getBlockSubscription }
) => createGetEpic(action$, getBlockByHashAsync, getBlockSubscription);
